/**
 * {@link https://ngrx.io/docs State} of this plugin
 */
export interface State {}
export namespace State {
  export const INITIAL: State = {}
}
